module.exports = __webpack_public_path__ + "static/media/3.b4323f2d.jpg";